import type { JSX } from 'react'
import type { ISkeletonUnitProps } from '../../SkeletonUnit'

import { SkeletonUnit } from '../../SkeletonUnit'
import { SkeletonUnitMargins } from '../../SkeletonUnit.h'

export interface ITimeLineSkeletonUnitProps extends ISkeletonUnitProps {}

export const TimeLineSkeletonUnit = ({
  height = '40px',
  margins = SkeletonUnitMargins.SIZE_30,
  ...rest
}: ITimeLineSkeletonUnitProps): JSX.Element => (
  <SkeletonUnit height={height} margins={margins} {...rest} />
)
